import bootstrap = require("bootstrap");
import { FailedFetchResponse, SuccessfulFetchResponse } from "./appFetch";
import { FailedWebRequestCallback, SuccessfulWebRequestCallback, Z } from "./query";

export interface PromptOptions {
    icon?: string;
    prompt?: string;
    class?: string;
    lock?: boolean;

    text?: string;
    default?: string;

    dismissText?: string;
    confirmText?: string;

    confirmButton?: boolean;
    dismissButton?: boolean;

    onConfirm?: Function;
    onDismiss?: Function;
}

export class AppModal {

    container: HTMLElement;
    bsModal: bootstrap.Modal;

    static getInstance(selector: any): AppModal {
        let match = Z.one(selector);
        if (match) {
            let data = Z.getData(match, 'app-modal');
            if (data) return <AppModal>data;
        }
        return null;
    }

    get isAsync() {
        return this.container && this.container.matches('.async-modals .modal');
    }

    constructor(container: HTMLElement) {
        this.container = container;
        this.bsModal = bootstrap.Modal.getOrCreateInstance(this.container);

        this.container.addEventListener('hide.bs.modal', ev => this.onHide(ev));
        this.container.addEventListener('hidden.bs.modal', ev => this.onHidden(ev));
        this.container.addEventListener('hidePrevented.bs.modal', ev => this.onHidePrevented(ev));
        this.container.addEventListener('show.bs.modal', ev => this.onShow(ev));
        this.container.addEventListener('shown.bs.modal', ev => this.onShown(ev));

        //let bsModal = this.bsModal;
    }

    static init() {
        Z.init('.modal', 'app-modals', el => {
            Z.setData(el, 'app-modal', new AppModal(el));
        });

        Z.init('[data-modal]', 'show-modal-trigger', el => {
            el.addEventListener('click', ev => {
                let selector = el.dataset.modal;
                AppModal.showModal(selector, () => {
                    if (el.dataset.afterModal) {
                        if (el.dataset.afterModal.startsWith('js:')) {
                            eval(el.dataset.afterModal.substring('js:'.length));
                        }
                    }
                }, el);
            });
        });

        Z.init('#confirmation-dialog', 'confirmation-dialog', modal => {
            Z.forEachFrom(modal, '.modal-footer .cancel-button', btn => {
                btn.addEventListener('click', ev => Z.confirmationDialogCancelled());
            });
            Z.forEachFrom(modal, '.modal-footer .approve-button', btn => {
                btn.addEventListener('click', ev => Z.confirmationDialogApproved());
            });
        });
    }

    static showModal(selector: any, andThen: Function = null, src: HTMLElement = null, afterShown: (modal: HTMLElement) => any = null) {
        //console.log(`showModal`, selector, andThen, src);

        if (selector.startsWith('/')) {
            Z.spinUp(src);
            fetch(selector)
                .then(resp => {
                    Z.spinDown();
                    if (resp.ok) {
                        resp.text()
                            .then(html => {
                                Z.forEach('.async-modals', container => {
                                    let dom = Z.parseHtmlAsTemplate(html);
                                    container.appendChild(dom);

                                    Z.updateLayout();

                                    let asyncModals = Z.selectFrom(container, '.modal');
                                    if (asyncModals.length) {
                                        let newModalDom = asyncModals[asyncModals.length - 1];
                                        let newModal = new AppModal(newModalDom);

                                        if (afterShown != null)
                                            newModal.afterShownCallback = afterShown;

                                        Z.setData(newModalDom, 'app-modal', newModal);
                                        newModal.bsModal.show();

                                        if (andThen && typeof andThen === 'function') {
                                            andThen(newModal.container, newModal);
                                        } else {
                                            if (andThen) {
                                                console.log(`'andThen' should be a function, instead it is ${typeof andThen}`, andThen);
                                            }
                                        }
                                    }
                                });
                            });
                    } else {
                        resp.text().then(txt => {
                            alert(`An error occurred:\n\n${txt}`);
                        });
                    }
                }).catch(err => {
                    alert(`An error occured: \n{err}`);
                });

        } else {
            Z.forEach(selector, el => {
                if (el.matches('.modal')) {
                    let modat = Z.getData(el, 'app-modal');
                    if (modat && modat.bsModal) {

                        modat.afterShownCallback = (modal) => {
                            if (afterShown) afterShown(modal);
                        };

                        (<bootstrap.Modal>modat.bsModal).show();
                        if (andThen && typeof andThen === 'function') {
                            andThen(modat.container, modat);
                        } else {
                            if (andThen) {
                                console.log(`'andThen' should be a function, instead it is ${typeof andThen}`, andThen);
                            }
                        }
                    }
                }
            });
        }
    }

    onHide(ev: Event) {
    }

    onHidden(ev: Event) {
        if (this.isAsync)
            this.container.remove();
    }

    onHidePrevented(ev: Event) {
    }

    afterShownCallback: (modal: HTMLElement) => any = null;

    onShown(ev: Event) {
        Z.forFirstFrom<HTMLInputElement>(this.container, '.focus-on-modal', el => {
            if (el.focus) el.focus();
            if (el.select) el.select();
        });

        if (this.afterShownCallback)
            this.afterShownCallback(this.container);
    }

    onShow(ev: Event) {
        Z.forEach('.context-menu.active', mi => mi.classList.remove('active'));
    }

}